import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "accordion-item"
}
const _hoisted_2 = { class: "d-none" }
const _hoisted_3 = { class: "accordion-header px-3 d-flex justify-content-between align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", {
  class: "fs-4 fw-bold mb-0 ms-4 py-6 w-50 w-md-100",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#info_body"
}, "Proposal info", -1)
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = {
  class: "accordion-icon ms-5",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#info_body"
}
const _hoisted_7 = { class: "svg-icon svg-icon-2x" }
const _hoisted_8 = {
  id: `info_body`,
  class: "accordion-collapse collapse",
  "aria-labelledby": "info_body",
  "data-bs-parent": "#copy_accordion"
}
const _hoisted_9 = { class: "accordion-body" }
const _hoisted_10 = { class: "my-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2 ms-1" }, "Proposer", -1)
const _hoisted_12 = { class: "my-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2 ms-1" }, "Proposal Name", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-warning m-0" }, "Acceptable chars: a~z 0~5", -1)
const _hoisted_15 = { class: "text-danger mt-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Authorization = _resolveComponent("Authorization")!

  return (!_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.counter), 1),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr071.svg" })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.proposer) = $event)),
                class: "form-control form-control-solid",
                name: "proposer",
                placeholder: "Enter proposer",
                readonly: ""
              }, null, 512), [
                [_vModelText, _ctx.proposer]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _hoisted_14,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
                class: "form-control form-control-solid",
                name: "name",
                placeholder: "Enter name"
              }, null, 512), [
                [_vModelText, _ctx.name]
              ]),
              _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.checkName), 1)
            ]),
            _hoisted_16,
            _createElementVNode("div", null, [
              _createVNode(_component_Authorization, {
                title: 'Requested Approvals',
                data: _ctx.data,
                onSetAuthorization: _ctx.setAuthorization
              }, null, 8, ["data", "onSetAuthorization"])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}